import { memo } from 'react';

import {
  isEyewearHit,
  isStrapHit,
  isWatchHit,
} from '@/integrations/algolia/helpers';
import type {
  EyewearHit,
  StrapHit,
  WatchHit,
} from '@/integrations/algolia/types';
import type { ProductCatalogModeCtaStyle } from '@/lib/types';

import { EyewearCard, StrapCard, WatchCard } from './components';

export type ProductListingCardProps = {
  bottomSlot?: React.ReactNode;
  cardClickHandler?: () => void;
  className?: string;
  customOrderFun?: () => Promise<object[] | undefined>;
  hideFavorite?: boolean;
  hit: WatchHit | StrapHit | EyewearHit;
  href?: string;
  imageSlot?: React.ReactNode;
  index?: number;
  isMostRelevantCta?: boolean;
  priority?: boolean;
  productCatalogMode?: boolean;
  productCatalogModeCtaStyle?: ProductCatalogModeCtaStyle;
  strapSizeDatas?: Record<string, any>;
};

export const ProductListingCard = memo(
  ({
    bottomSlot,
    cardClickHandler,
    className,
    customOrderFun,
    hideFavorite = false,
    hit,
    href,
    imageSlot,
    isMostRelevantCta = false,
    priority = false,
    productCatalogMode,
    productCatalogModeCtaStyle,
    strapSizeDatas,
  }: ProductListingCardProps) => {
    if (isWatchHit(hit)) {
      return (
        <WatchCard
          bottomSlot={bottomSlot}
          cardClickHandler={cardClickHandler}
          className={className}
          customOrderFun={customOrderFun}
          data-test-id='ProductListingCardWatchCard'
          hideFavorite={hideFavorite}
          hit={hit as WatchHit}
          href={href}
          imageSlot={imageSlot}
          priority={priority}
          productCatalogMode={productCatalogMode}
          productCatalogModeCtaStyle={productCatalogModeCtaStyle}
          sizes='(max-width: 600px) 50vw, (max-width: 992px) 250px, (max-width: 1280px) 300px, 350px'
        />
      );
    }

    //TODO check is support strap material
    if (isStrapHit(hit)) {
      return (
        <StrapCard
          cardClickHandler={cardClickHandler}
          data-test-id='ProductListingCardStrapCard'
          hit={hit as StrapHit}
          isMostRelevantCta={isMostRelevantCta}
          priority={priority}
          productCatalogModeCtaStyle={productCatalogModeCtaStyle}
          sizes='50vw'
          strapSizeDatas={strapSizeDatas}
          type='square'
        />
      );
    }

    if (isEyewearHit(hit)) {
      return (
        <EyewearCard
          cardClickHandler={cardClickHandler}
          data-test-id='ProductListingCardStrapCard'
          hit={hit}
          priority={priority}
          productCatalogModeCtaStyle={productCatalogModeCtaStyle}
          sizes='50vw'
          type='square'
        />
      );
    }

    return null;
  },
);

ProductListingCard.displayName = 'ProductListingCard';
